import UploadContent from './AddEditEmailEventConfiguration';

export default UploadContent;
